export default __webpack_public_path__ + "static/media/main-desktop-background.5d7ff0e9.jpg";